import React from "react";

import { useRecoilState, useRecoilValue } from "recoil";
import { ArrowDownCircleIcon, TicketIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetScorecardReportDaily from "./hooks/useGetScorecardReportDaily";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { scorecardReportsDaily } from "../../OfficeSettings/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import DownloadButton from "../../../../components/DownloadButton";

interface ScorecardReportDailyProps {}

export const ScorecardReportDaily: React.FC<ScorecardReportDailyProps> = () => {
  const searchInputsData = {
    Account: "",
    CaseNumber: "",
    Contact: "",
    CreatedBy: "",
    CreatedDate: new Date().toLocaleString(),
    Status: "",
    ActionRequiredOrNotificationC: "",
    ContactId: null,
  };

  const { data: searchScorecard, isLoading: searchScorecardLoading } =
    useGetScorecardReportDaily(searchInputsData);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [showFromScorecardReportsDaily, setShowFromScorecardReportsDaily] =
    useRecoilState(scorecardReportsDaily);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  let today = new Date().toLocaleString();
  const GetDaysBetweenDates = (d0, d1) => {
    let msPerDay = 8.64e7;
    let x0 = new Date(d0);
    let x1 = new Date(d1);
    return Math.round(
      (x0.setHours(12, 0, 0) - x1.setHours(12, 0, 0)) / msPerDay
    );
  };
  interface IScorecardReportDaily {
    closeReasonC: string;
    createdBy: string;
    caseNumber: string;
    contact: string;
    account: string;
    type: string;
    subject: string;
    policyC: string;
    customerC: string;
    amountC: string;
    actionRequiredOrNotificationC: string;
    generalGroupC: string;
    descriptiveGroupC: string;
    scorecardAreaC: string;
    actionToTakeC: string;
    scorecardAreaOtherC: string;
    writeOffAmountC: string;
    createdDate: string;
    closedDate: string;
    status: string;
    state: string;
    districtManager: string;
  }

  //For downloading table data
  const exportdata = searchScorecard?.map((scrd: IScorecardReportDaily) => {
    return {
      "Case Owner": scrd.createdBy,
      "Close Reason": scrd.closeReasonC,
      "Created By": scrd.createdBy,
      "Case Number": scrd.caseNumber,
      "Employee Name": scrd.contact,
      "Office Name": scrd.account,
      State: scrd.state,
      "District Manager": scrd.districtManager,
      Type: scrd.type,
      Subject: scrd.subject,
      "Policy#": scrd.policyC,
      "Customer#": scrd.customerC,
      Amount: scrd.amountC,
      "Action Required OR Notification": scrd.actionRequiredOrNotificationC,
      "General Group": scrd.generalGroupC,
      "Descriptive Group": scrd.descriptiveGroupC,
      "Scorecard Area": scrd.scorecardAreaC,
      "Action To Take": scrd.actionToTakeC,
      "Scorecard Area (Other)": scrd.scorecardAreaOtherC,
      "Write Off Amount": scrd.writeOffAmountC,
      "Date/Time Opened": scrd.createdDate
        ? new Date(scrd.createdDate)?.toLocaleString()
        : "",
      "Date/Time Closed": scrd.closedDate
        ? new Date(scrd.closedDate)?.toLocaleString()
        : "",
      Age: scrd.closedDate
        ? GetDaysBetweenDates(scrd.closedDate, scrd.createdDate)
        : GetDaysBetweenDates(today, scrd.createdDate),
      Open:
        scrd.status === "81-Notified Agent and Closed" ||
        scrd.status === "80-Closed" ||
        scrd.status === "82-Closed - No Response"
          ? "False"
          : "True",
      Closed:
        scrd.status === "81-Notified Agent and Closed" ||
        scrd.status === "80-Closed" ||
        scrd.status === "82-Closed - No Response"
          ? "True"
          : "False",
    };
  });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "ScorecardReportDaily_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };

  const officeColumns = [
    { title: "Case Owner", field: "createdBy" },
    { title: "Close Reason", field: "closeReasonC" },
    { title: "Created By", field: "createdBy" },
    {
      title: "Scorecard Number",
      field: "caseNumber",
      // render: (rowdata) => {
      //   return (
      //     <div
      //       className="cursor-pointer"
      //       onClick={() => {
      //         const url = "/carrieragreementmgmt/scorecard";
      //         history.push({
      //           pathname: `/carrieragreementmgmt/scorecard?actionFrom=ScorecardReportDaily&caseNumber=${rowdata?.caseNumber}`,
      //           // state: {
      //           //   officeId: rowData?.officeId,
      //           // },
      //         });
      //         let userTabs = [
      //           {
      //             to: "",
      //           },
      //         ];
      //         [...CarrierAgreementMgmtTabs].forEach((tabs) => {
      //           let temp = [...userPermissions].filter(
      //             (user) => user === tabs.permission
      //           );
      //           if (temp.length > 0)
      //             userTabs.push({
      //               to: tabs.to,
      //             });
      //         });
      //         userTabs.shift();
      //         const index = userTabs.findIndex((c) => c.to === url);
      //         setSelectedIndex(index);
      //         setShowFromScorecardReportsDaily(true);
      //       }}
      //     >
      //       <span className="blueAndBold underline">
      //         {String(rowdata.caseNumber)?.padStart(10, "0")}
      //       </span>
      //       <br></br>
      //     </div>
      //   );
      // },
    },
    { title: "Employee Name", field: "contact" },
    {
      title: "Office Name",
      field: "account",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  officeId: rowData?.account,
                  action: "ScorecardReportDaily",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
              setShowFromScorecardReportsDaily(true);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.account}
            </span>
          </div>
        );
      },
    },
    { title: "State", field: "state" },
    { title: "District Manager", field: "districtManager" },
    { title: "Type", field: "type" },
    { title: "Subject", field: "subject" },
    { title: "Policy#", field: "policyC" },
    { title: "Customer#", field: "customerC" },
    { title: "Amount", field: "amountC" },
    {
      title: "Action Required OR Notification",
      field: "actionRequiredOrNotificationC",
    },
    { title: "General Group", field: "generalGroupC" },
    { title: "Descriptive Group", field: "descriptiveGroupC" },
    { title: "Scorecard Area", field: "scorecardAreaC" },
    { title: "Action To Take", field: "actionToTakeC" },
    { title: "Scorecard Area (Other)", field: "scorecardAreaOtherC" },
    { title: "Write Off Amount", field: "writeOffAmountC" },
    {
      title: "Date/Time Opened",
      field: "createdDate",
      render: (rowData) =>
        rowData.createdDate
          ? new Date(rowData.createdDate)?.toLocaleString()
          : "",
    },
    {
      title: "Date/Time Closed",
      field: "closedDate",
      render: (rowData) =>
        rowData.closedDate
          ? new Date(rowData.closedDate)?.toLocaleString()
          : "",
    },

    {
      title: "Age",
      field: "",
      render: (rowData) =>
        rowData.closedDate
          ? GetDaysBetweenDates(rowData.closedDate, rowData.createdDate)
          : GetDaysBetweenDates(today, rowData.createdDate),
    },
    {
      title: "Open",
      name: "Open",
      cellStyle: {
        width: 120,
        maxWidth: 120,
      },
      render: (row) => (
        <div className="">
          {row.status === "81-Notified Agent and Closed" ||
          row.status === "80-Closed" ||
          row.status === "82-Closed - No Response" ? (
            <div className="">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                defaultChecked={false}
              />
            </div>
          ) : (
            <div className="">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                defaultChecked={true}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Closed",
      name: "Closed",
      cellStyle: {
        width: 120,
        maxWidth: 120,
      },
      render: (row) => (
        <div className="">
          {row.status === "81-Notified Agent and Closed" ||
          row.status === "80-Closed" ||
          row.status === "82-Closed - No Response" ? (
            <div className="">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                defaultChecked={true}
              />
            </div>
          ) : (
            <div className="">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                defaultChecked={false}
              />
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <TicketIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Scorecard Report
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Scorecard Report (Daily)
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {searchScorecard?.length}
              </span>
            </div>

            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata()}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={searchScorecard}
            isLoading={searchScorecardLoading}
            columns={officeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
